import { Spinner } from '@chakra-ui/react';
import api from '@common/api';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { APP_CONTEXT, RESPONSIVE_MODE } from '../constants';
import { PortfolioAsset } from '../types';
import { AssetApp } from './AssetApp';
import AssetDesktop from './AssetDesktop';
import AssetMobile from './AssetMobile';

const MOBILE_BREAK_POINT = 626;

export type AssetState = 'LOADING' | 'EMPTY' | 'APP' | 'MOBILE' | 'DESKTOP';
export type AssetBlockProps = { asset: PortfolioAsset };

export const Asset: React.FC = () => {
  const [currentState, setCurrentState] = useState<AssetState>('LOADING');
  const [asset, setAsset] = React.useState<PortfolioAsset | null>();

  const [searchParams] = useSearchParams();
  const isAppVersion = searchParams.get('context') === APP_CONTEXT.APP;
  const preview = searchParams.get('preview') === 'true';
  const viewParam = searchParams.get('view');

  const { assetId } = useParams();

  const updateFormat = () => {
    const newFormat = window.innerWidth > MOBILE_BREAK_POINT ? 'DESKTOP' : 'MOBILE';
    setCurrentState(isAppVersion ? 'APP' : newFormat);
  };

  const loadData = async () => {
    const asset = await api.getPortfolioAsset(assetId ?? '', preview);
    setAsset(asset);

    if (asset) {
      let view: 'MOBILE' | 'DESKTOP';

      switch (viewParam) {
        case RESPONSIVE_MODE.MOBILE:
          view = 'MOBILE';
          break;
        case RESPONSIVE_MODE.DESKTOP:
          view = 'DESKTOP';
          break;
        default:
          view = window.innerWidth > MOBILE_BREAK_POINT ? 'DESKTOP' : 'MOBILE';
          break;
      }

      setCurrentState(isAppVersion ? 'APP' : view);
    } else {
      setCurrentState('EMPTY');
    }
  };

  useEffect(() => {
    loadData();
    if (!isAppVersion) window.addEventListener('resize', updateFormat);
    return isAppVersion
      ? void 0
      : () => {
          window.removeEventListener('resize', updateFormat);
        };
  }, []);

  let content = null;
  switch (currentState) {
    case 'LOADING':
      content = (
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
          }}>
          <Spinner />
        </div>
      );
      break;
    case 'APP':
      content = asset ? <AssetApp asset={asset} /> : null;
      break;
    case 'DESKTOP':
      content = asset ? <AssetDesktop asset={asset} /> : null;
      break;
    case 'MOBILE':
      content = asset ? <AssetMobile asset={asset} /> : null;
      break;
  }
  return content;
};
